import Vue from "vue";
import VueI18n from "vue-i18n";
import es from "../translations/es";
import en from "../translations/en";
import ru from "../translations/ru";
import de from "../translations/de";
import pt from "../translations/pt";
import fr from "../translations/fr";
import moment from "moment";

Vue.use(VueI18n);

let userLang = navigator.language.split("-");
let locale = userLang[0];

const messages = {
  es: es,
  en: en,
  ru: ru,
  de: de,
  pt: pt,
  fr: fr,
};

const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: "en",
  messages,
});

moment.locale(locale);

export default i18n;
